import { useState, useRef, useEffect } from "react"
import {
  ChevronDownIcon,
  PencilIcon,
  ArchiveBoxArrowDownIcon,
  AdjustmentsHorizontalIcon,
} from "@heroicons/react/24/outline"

const ActionsDropdown = ({ setShowForm, handleArchive, archiveMutation }) => {
  const [open, setOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  return (
    <div className='relative' ref={dropdownRef}>
      <button
        type='button'
        onClick={() => setOpen((prev) => !prev)}
        className='flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-800 rounded-md hover:bg-gray-200 transition'
      >
        <AdjustmentsHorizontalIcon className='w-4 h-4' />
        <span className='text-sm font-medium text-blue-800'>More Actions</span>
        <ChevronDownIcon
          className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className='absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50'>
          <button
            onClick={() => {
              setShowForm(true)
              setOpen(false)
            }}
            className='w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
          >
            <PencilIcon className='w-4 h-4' />
            Edit Program
          </button>

          <button
            onClick={() => {
              handleArchive()
              setOpen(false)
            }}
            disabled={archiveMutation.isLoading}
            className='w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50'
          >
            <ArchiveBoxArrowDownIcon className='w-4 h-4' />
            {archiveMutation.isLoading ? "Archiving..." : "Archive"}
          </button>
        </div>
      )}
    </div>
  )
}

export default ActionsDropdown
